import { combineReducers } from 'redux';
import { all, fork } from 'redux-saga/effects'; // fork 권장
// 'invocie' 오타 주의: 'invoice'로 수정하는 것이 좋습니다.
import invoiceMaintenance, { invoiceMaintenanceSaga } from './invoiceMaintenance'; 

const invoiceMaintenanceModule = combineReducers({
  invoiceMaintenance, 
});

export function* invoiceMaintenanceModuleSaga() {
  yield all([
    fork(invoiceMaintenanceSaga)
  ]);
}

export default invoiceMaintenanceModule;
